import type { AreaCatalog } from '../area';
import type { phases as en } from '../en/phases';

export const phases = {
  // --- The page head ---
  'phases.page.title': 'Ablaufphasen',
  'phases.page.sub': 'Abläufe und ihre Phasen',
  'phases.page.across': '{items} in {flows}',
  'phases.items': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  'phases.page.flows': { one: '{count} Ablauf', other: '{count} Abläufen' },
  'phases.verdicts': {
    one: '{count} braucht eine Bewertung',
    other: '{count} brauchen eine Bewertung',
  },
  'phases.page.empty':
    'Noch keine Abläufe. Ein Ablauf ist eine feste Folge von Phasen mit Entscheidungen an den Schwellen, und jede Aufgabe, die in einen Ablauf aufgenommen wird, erscheint hier in seiner Folge. Erstelle einen unter Abläufe und nimm dann Aufgaben über ihre Seite oder über ein Board mit Phasen als Spalten auf.',
  // --- The filter ---
  'phases.filter.label': 'Aufgaben im Ablauf filtern',
  'phases.filter.all': 'Alle',
  'phases.filter.verdict': 'Bewertung offen',
  'phases.filter.emptyVerdict':
    'Keine Schwelle wartet auf eine Bewertung. Die Tagesordnung ist leer.',
  'phases.filter.emptyAll': 'Noch keine Abläufe.',
  // --- A flow's entry and its pipeline ---
  'phases.flow.noMembers': 'noch keine Aufgaben',
  'phases.flow.configure': 'einrichten',
  'phases.flow.empty':
    'Noch keine Aufgaben in diesem Ablauf. Nimm sie über die Seite einer Aufgabe (+ Ablauf) oder über ein Board mit seinen Phasen als Spalten auf.',
  'phases.pipeline.drifted': 'Keine Phase mehr',
  // --- A member's card ---
  'phases.card.closed': 'abgeschlossen',
  'phases.card.delivered': 'fertig',
  'phases.card.verdict.accepted': 'abgenommen',
  'phases.card.verdict.disputed': 'Abnahme verweigert',
  'phases.card.heldTitle': 'Angehalten',
  'phases.card.heldTitleReason': 'Angehalten: {reason}',
  'phases.card.held': 'angehalten',
  'phases.card.heldReason': 'angehalten: {reason}',
  'phases.card.position': 'Position „{key}“',
  'phases.card.needsVerdict': 'Bewertung offen',
  'phases.card.unmet': '{count} an der Schwelle nicht erfüllt',
} as const satisfies AreaCatalog<typeof en>;
